module.exports = __webpack_public_path__ + "img/correcto.8b51982c.png";